import React from "react";

import { Truncated } from "~/components/truncated";
import { cx } from "~/tools/class-variance";

import { COMPONENT_PATH } from "../../../routes/Routes";
import { LinkTo, type NavigationSearchParams } from "../link";

export interface ComponentLinkProps {
	componentIdentifier: string;
	text: string;
	search?: NavigationSearchParams;
	className?: string;
	onClick?: React.MouseEventHandler<HTMLAnchorElement>;
	tooltip?: React.ReactNode;
}

export const ComponentLink = React.forwardRef<HTMLAnchorElement, ComponentLinkProps>(
	({ text, componentIdentifier, search: customSearch, tooltip, onClick, className, ...props }, ref) => (
		<LinkTo
			onClick={(event) => {
				event.stopPropagation();
				onClick?.(event);
			}}
			params={{
				identifier: componentIdentifier,
			}}
			ref={ref}
			search={(search) => ({
				...search,
				query: undefined,
				explore: undefined,
				sortBy: undefined,
				filterBy: undefined,
				...customSearch,
			})}
			theme="tertiary"
			// a table row where the link is located has a click handler
			// so we need to stop propagation of the click event
			// otherwise the click handler of the table row will be called
			to={COMPONENT_PATH}
			{...props}
			className={cx("text-inherit", className)}
		>
			<Truncated tooltip={tooltip} truncate="middle">
				{text}
			</Truncated>
		</LinkTo>
	),
);
